<template>
  <div>
    <footer class="cpoy-right-bg" ref="copyrightPosition">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="social-footer">
              <ul>
                <li>
                  <a href="#" ><i class="fa fa-facebook" aria-hidden="true"></i></a>
                </li>
                <li>
                  <a href="#" ><i class="fa fa-google-plus" aria-hidden="true"></i
                  ></a>
                </li>
                <li>
                  <a href="#" ><i class="fa fa-twitter" aria-hidden="true"></i
                  ></a>
                </li>
                <li>
                  <a href="#" ><i class="fa fa-instagram" aria-hidden="true"></i
                  ></a>
                </li>
                <li>
                  <a href="#"><i class="fa fa-rss" aria-hidden="true"></i></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-12 text-center">
            <p class="copyright">
              2025-26 Copyright by themeforest Powered by Pixelstrep
            </p>
          </div>
        </div>
      </div>
    </footer>
    <div class="tap-top" @click="executeScroll()" :style="[display ? {'display':'block'} : { 'display':'none'} ]">
      <div>
        <i class="fa fa-angle-up" aria-hidden="true"></i>
      </div>
    </div>
    <div id="fb-root"></div>
    <div
      class="fb-customerchat" attribution="setup_tool" page_id="2123438804574660" theme_color="#8E49DD" logged_in_greeting="Hi! Welcome to PixelStrap Themes  How can we help you?" logged_out_greeting="Hi! Welcome to PixelStrap Themes  How can we help you?"
    ></div>
  </div>
</template>
<script>
export default {
      name: 'TapTop',
      data() {
        return {
          display: false,
        };
      },
      created() {
        window.addEventListener('scroll', this.handleScrolls);
      },
      unmounted() {
        window.removeEventListener('scroll', this.handleScrolls);
      },
      methods: {
        executeScroll() {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        },
        handleScrolls() {
          if (window.scrollY > 600) {
            this.display = true;
          } else {
            this.display = false;
          }
        },
      },
    };
</script>
